import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import MSColumn2D from '../mscolumn2d';
import { HUNDREDSTRING, preDefStr } from '../../../../fc-core/src/lib';

var UNDEF,
    SEVENTYSTRING = preDefStr.SEVENTYSTRING,
    _setDefaultConfig = function _setDefaultConfig() {
  var a = this.config;
  a.anchorborderthickness = 1, a.anchorimageurl = UNDEF, a.anchorimagepadding = 1, a.anchorsides = 1, a.anchoralpha = UNDEF, a.anchorbgalpha = HUNDREDSTRING, a.anchorimagealpha = HUNDREDSTRING, a.anchorimagescale = 100, a.anchorstartangle = 90, a.anchorshadow = 0, a.anchorbgcolor = UNDEF, a.anchorbordercolor = UNDEF, a.anchorradius = 3, a.showvalues = 1, a.plotfillalpha = SEVENTYSTRING, a.linedashlen = 5, a.linedashgap = 4, a.linedashed = UNDEF, a.linealpha = HUNDREDSTRING, a.linethickness = 2, a.drawfullareaborder = 1, a.connectnulldata = 0;
};

var AreaBase =
/*#__PURE__*/
function (_MSColumn2D) {
  _inherits(AreaBase, _MSColumn2D);

  function AreaBase() {
    _classCallCheck(this, AreaBase);

    return _possibleConstructorReturn(this, _getPrototypeOf(AreaBase).apply(this, arguments));
  }

  _createClass(AreaBase, [{
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      _get(_getPrototypeOf(AreaBase.prototype), "__setDefaultConfig", this).call(this), _setDefaultConfig.call(this);
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'AreaBase';
    }
  }]);

  return AreaBase;
}(MSColumn2D);

export default AreaBase;
export { _setDefaultConfig };